<template lang="pug">
.content.categ-exercise-content
  .row.categ-exercise-body
    .col-md-12.col-md-header
      .header Danh mục bài tập
      .box-categ-exercise(:style="$isMobile() ? 'float: none; margin-top: 0;' : ''")
        button.btn.btn-categ-exercise-add(@click="onAddCategory") Thêm danh mục
      .clearfix
    .col-md-12
      //- .card.card-categ-exercise-action
      .box-table-categ-exercise(v-on:scroll.passive='handleScroll' v-if="!mobile")
        tbCateExercise(
          @onfilterbyname="filterbyname",
          @onItemDelete="onCateFormDelete",
          @onItemEdit="onCateFormEdit",
          @onFilterBlue="filterBlue",
          :lstFilter='lstFilter',
          :data='category',
          :columns='columns',
          :inlineFilter='true'
          :doSort='true'
        )
      .card.card-categ-exercise(v-else style="margin-top: 0;border-radius: 10px;")
        .row-header
          span.label-header
            span.name Tên danh mục
            span.fas.fa-sort-alpha-down(@click="filterItems(sort, 6)" :class="sort ? 'checked' : ''")
          .field-header
            input(@change="filterbyname($event.target.value)" placeholder="Tìm theo tên")
        .clearfix
        .empty-data(v-if='category.length === 0') 
          span(style='font-weight:bold;') Không tìm thấy dữ liệu
        .list-item(v-else style="overflow-y: scroll;" v-on:scroll.passive='handleScrollX')
          .row-item(v-for='(item, index) in category')
            .row-data
              .board-info
                span {{item.name}}
            .row-data
              span.label-header Ngày tạo:
              .row-value {{formatDate(item.created_at)}}
            .row-data
              span.label-header Người tạo:
              .row-value {{item.created_user.fullname}}
            .row-data
              span.label-header Ngày cập nhật:
              .row-value {{formatDate(item.updated_at)}}
            .row-data
              span.label-header Người cập nhật:
              .row-value {{item.updated_user.fullname}}
            .row-data
              .action-buttons
                span.list-action
                  small(@click="onCateFormEdit(item)")
                    img(:src="require('../../../assets/images/faces/ic_edit.svg')")
                span.list-action
                  small.support(@click="onCateFormDelete(item)")
                    img(:src="require('../../../assets/images/theory/delete-24px.svg')")
</template>

<script>
import gql from 'graphql-tag'
import graphql from '../../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import tbCateExercise from '../../Question/Category/tbCateQuestion'
import popupAdd from './popupAdd'
import popupDelete from './popupDelete'
import popupEdit from './popupEdit'
import moment from 'moment'
export default {
  components: {tbCateExercise, MdNotification, popupAdd, popupDelete, popupEdit, moment},
  data() {
    return {
      category: [],
      columns: [
        { key: 'stt', title: 'STT' },
        { key: 'name', title: 'Tên danh mục' },
        { key: 'created_at', title: 'Ngày tạo', type: 'date' },
        { key: 'created_user', title: 'Người tạo', type: 'created_user' },
        { key: 'updated_at', title: 'Ngày cập nhật', type: 'date' },
        { key: 'updated_user', title: 'Người cập nhật', type: 'updated_user' },
        { key: 'action', title: '', type: 'action' }
      ],
      limit: 10,
      offset: 0,
      filter: '{is_delete: {_eq: false}, created_by: {_eq: "' + this.$store.getters.user + '"}',
      filtername: '',
      mobile: false,
      sort: false,
      orderBy: '{id: desc}',
      lstFilter: {
        order_by: false
      }
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - HH:mm')
    },
    filterbyname(payload) {
      // console.log(payload)
      if (payload !== '') {
        this.filtername = ', name: {_ilike: "%' + payload + '%"}'
      } else {
        this.filtername = ''
      }
    },
    onAddCategory() {
      this.$modal.show(popupAdd, {
        saveFunction: this.onCateFormAdd
      }, {
        height: 'auto',
        classes: ['col-6'],
        adaptive: true,
        resize: true,
        clickToClose: false
      })
    },
    onCateFormAdd(payload) {
      this.$apollo.mutate({
        mutation: gql(graphql.CREATE_CATEGORY_EXERCISE),
        variables: {
          name: payload.name,
          created_by: this.$store.getters.user
        }
        // update: (store, { data: { insert_category_exercise } }) => {
        //   // Read the data from our cache for this query.
        //   var query = graphql.GET_CATEGORY_EXERCISE_FILTER(this.filter + this.filtername + '}', this.orderBy, this.offset, this.limit)
        //   // Read the data from our cache for this query.
        //   // console.log(query)
        //   const data = store.readQuery({ query: gql(query) })
        //   const insertedCategory = insert_category_exercise.returning
        //   data.category_exercise.splice(0, 0, insertedCategory[0])
        //   store.writeQuery({ query: gql(query), data })
        // }
      }).then((data) => {
        // Result
        this.$apollo.queries.category.refetch()
        this.showNotification('Danh mục <b>' + payload.name + '</b> đã được thêm', 'success', 'top', 'right', 5000)
      }).catch((e) => {
        // Error
        console.error(e)
      })
    },
    onCateFormDelete(payload) {
      // console.log(payload)
      this.$modal.show(popupDelete, {
        id: payload.id,
        name: payload.name,
        saveFunction: this.onItemDeleteParent
      }, {
        height: 'auto',
        classes: ['col-6'],
        adaptive: true,
        clickToClose: false
      })
    },
    onCateFormEdit(payload) {
      this.$modal.show(popupEdit, {
        id: payload.id,
        name: payload.name,
        saveFunction: this.onItemEditParent
      }, {
        height: 'auto',
        classes: ['col-6'],
        adaptive: true,
        clickToClose: false
      })
    },
    async checkCategoryUsed(id) {
      if (id > 0) {
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_COUNT_CATEGORY_EXERCISE_USED),
          fetchPolicy: 'no-cache',
          variables: {
            where: {categ_id: {_eq: id}}
          },
          error(error) {
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0)
            }
            console.error(error.message)
          }
        })
        if (data.exercise_aggregate && data.exercise_aggregate.aggregate.count > 0) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    async onItemDeleteParent(payload) {
      var categUsed = await this.checkCategoryUsed(payload.id)
      if (!categUsed) {
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_CATEGORY_EXERCISE),
          variables: {
            id: payload.id,
            name: payload.name,
            is_delete: true
          }
          // update: (store, { data: { updateCategoryExercise } }) => {
          //   // Read the data from our cache for this query.
          //   var query = graphql.GET_CATEGORY_EXERCISE_FILTER(this.filter + this.filtername + '}', this.orderBy, this.offset, this.limit)
          //   const data = store.readQuery({ query: gql(query) })
          //   var toBeDeleted = null
          //   for (var i = 0; i < data.category_exercise.length; i++) {
          //     var sub = data.category_exercise[i]
          //     if (sub.id === payload.id) {
          //       toBeDeleted = i
          //     }
          //   }
          //   if (toBeDeleted !== null) data.category_exercise.splice(toBeDeleted, 1)
          //   store.writeQuery({ query: gql(query), data })
          // }
        }).then((data) => {
          this.$apollo.queries.category.refetch()
          this.showNotification('Danh mục bài tập <strong>' + payload.name + '</strong> đã bị xóa', 'success', 'top', 'right', 7000)
        }).catch((error) => {
          // Error
          console.error(error)
        })
      } else {
        this.showNotification('Danh mục bài tập <strong>' + payload.name + '</strong> đang được sử dụng', 'danger', 'top', 'right', 7000)
      }
    },
    onItemEditParent(payload) {
      this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_CATEGORY_EXERCISE),
        variables: {
          id: payload.id,
          name: payload.name,
          is_delete: false
        }
        // update: (store, { data: { updateCategoryExercise } }) => {
        //   // Read the data from our cache for this query.
        //   var query = graphql.GET_CATEGORY_EXERCISE_FILTER(this.filter + this.filtername + '}', this.orderBy, this.offset, this.limit)
        //   const data = store.readQuery({ query: gql(query) })
        //   var subUpdated = data.category_exercise.find(s => s.id === payload.id)
        //   subUpdated.name = payload.name
        //   subUpdated.updated_by = this.$store.getters.user
        //   store.writeQuery({ query: gql(query), data })
        // }
      }).then((data) => {
        // Result
        this.$apollo.queries.category.refetch()
        this.showNotification('Danh mục câu hỏi <strong>' + payload.name + '</strong> đã được cập nhật', 'success', 'top', 'right', 5000)
      }).catch((error) => {
        // Error
        console.error(error)
      })
    },
    filterItems(id, type) {
      if (type === 6) {
        this.sort = !this.sort
        this.lstFilter.order_by = this.sort
      }
      this.$apollo.queries.category.refetch()
    },
    filterBlue(payload) {
      this.lstFilter.order_by = payload.order_by
      this.$apollo.queries.category.refetch()
    }
  },
  mounted() {
    if (window.innerWidth < 991) {
      this.mobile = true
    } else {
      this.mobile = false
    }
  },
  apollo: {
    category: {
      query() {
        // console.log(graphql.GET_CATEGORY_EXERCISE_FILTER(this.filter + this.filtername + '}', this.offset, this.limit))
        if (this.lstFilter.order_by) this.orderBy = '{name: asc}'
        else this.orderBy = '{id: desc}'
        return gql(graphql.GET_CATEGORY_EXERCISE_FILTER(this.filter + this.filtername + '}', this.orderBy, this.offset, this.limit))
      },
      fetchPolicy: 'no-cache',
      update: data => {
        if (data.category_exercise && data.category_exercise !== null) {
          for (var i = 0; i < data.category_exercise.length; i++) {
            data.category_exercise[i].stt = i + 1
          }
          // console.log(data.category_exercise)
          return data.category_exercise
        }
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.categ-exercise-content {
  .categ-exercise-body {
    .col-md-header {
      margin-bottom: 10px;
    }
    .header {
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      color: #5F6468;
      display: inline-block;
    }
    .box-categ-exercise {
      float: right;
      margin-top: -10px;
      .btn-categ-exercise-add {
        background-color: #FFD311;
        width: 214px;
        height: 48px;
        border-radius: 5px;
        color: black;
        text-transform: none;
        font-size: 14px;
        font-family: 'adobe-clean' sans-serif;
        border: 1px solid #FFD311;
        padding: 0;
        &:active {
          background-color: #CCAD7B;
          color: black;
        }
      }
    }
    // danh sach lien ket table
    .box-table-categ-exercise {
      background: white;
      box-shadow: 0px 1px 3px #00000029;
      padding: 10px;
      max-height: 385px; 
      overflow-y: scroll;
      border-radius: 10px;
    }
  }
}
@media (max-width: 414px) {
  .card-categ-exercise {background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029; padding: 15px;
    .row-header{border: 1px solid #E0E0E0;border-top: 0;background: #FAFAFA 0% 0% no-repeat padding-box; 
      .label-header{
        .name {width: 60px; line-height: 15px; display: inline-flex; vertical-align: middle; padding: 4px 0;}
        .fa-sort-alpha-down {
          &.checked {color: #219AFF;}
          padding-left: 9px; vertical-align: middle;
        }
        display: inline-block; line-height: 30px;width: 30%;font-weight: bold;text-align: right; padding-right: 10px;
      }
      .field-header{padding: 5px 10px; display: inline-block; width: 70%; background: #EAEAEA 0% 0% no-repeat padding-box;
        input, select{width: 100%;border-radius: 10px; padding: 3px 10px; background: #fff;border: 1px solid #B4B4B4; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;}
      }
      &:first-child{border-top: 1px solid #E0E0E0;border-radius: 10px; overflow: hidden;}
      &.last{border-bottom-left-radius: 10px !important;border-bottom-right-radius: 10px !important;overflow: hidden;}
    }
    .empty-data{margin-top: 20px; background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 10px; text-align: center; padding: 5px;}
    .list-item{margin-top: 15px;
      .row-item{background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 10px; padding: 8px 8px;margin-bottom: 10px;
        &:first-child{margin-bottom: 10px;}
        &:last-child {margin-bottom: 0;}
        .show-more {
          .row-data {
            .row-value {color: #343A40;}
            &:last-child {
              .row-value {padding-bottom: 0;}
            }
          }
        }
        .row-data{
          .label-header{display: inline-block;text-align: left; padding-right: 8px; color: #969FAD;}
          .row-value{padding-bottom: 8px; display: inline-block;
            &.title{font-size: 15px; font-weight: bold; margin-bottom: 15px;display: block;}
            &.link{text-decoration: underline; color:#554BC1;}
            select{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 10px; opacity: 1; padding: 6px;width: 100%;}
            small{margin-right: 10px; float: left;
              &:last-child{margin-right: 0;}
              img{width: 16px;height: 16px;}
            }
            img.img{border-radius: 50%;width: 30px; height: 30px;}
          }
          .board-info{ width: 100%; display: inline-flex; margin-bottom: 8px;
            span{font-size: 15px; font-weight: bold; display: block; color: #9F6A28; overflow: hidden; white-space: nowrap;}
          }
          .filter-item {
            span {
              padding: 4px 8px; 
              background: #F2F2F2; 
              border-radius: 10px; 
              color: #969FAD; 
              box-shadow: 0px 1px 3px #00000029; 
              margin: 0 8px 8px 0;
              cursor: pointer;
              display: inline-block;
              &.checked {
                background: #219AFF; 
                color: white;
              }
            }
          }
          .action-buttons {
            text-align: right;
            // margin-bottom: 8px;
            .list-action {
              small{width: 16px; height: 16px; margin-right: 16px; display: inline-block;
                &.support {margin-right: 0px;}
                img{max-width: 100%; height: auto; cursor: pointer;}
                .fas {cursor: pointer;}
                .ic-public {font-size: 16px;  color: #333333; vertical-align: text-bottom;}
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?5ff1d174